import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

export interface IApiKeyResponse {
  message: string;
  payload: IApiKeyPayload;
}

export interface IApiKeyPayload {
  apiKeys: IApiKey[];
}

export interface IApiKey {
  id: string;
  key: string;
  expiresAt: string;
  status: string;
}

@Injectable({
  providedIn: 'root',
})
export class ApiKeyService {
  constructor(private api: ApiService) {}

  getApiKeys(): Observable<IApiKeyResponse> {
    return this.api.GET<IApiKeyResponse>('api-keys');
  }
}
